export default {
    originatorView: {
        MustBeValidCodeOriginator: 'Codigo Originador debe ser válido',
        originatorsList: 'Originators List'
    }
};
